import { EnvelopeCount, EnvelopePaper } from '~/tenants/bre/performable/print/envelopes/BreEnvelopesConfig';

type CountMap = Record<EnvelopeCount, string>;

type PaperMap = Record<EnvelopePaper, Partial<CountMap>>;

export const BreEnvelopesRate: PaperMap = {
  smooth_white: {
    250: '285',
    500: '330',
    1000: '400',
    2500: '600',
  },
};

export const BreEnvelopesPay: PaperMap = {
  smooth_white: {
    250: '245',
    500: '285',
    1000: '345',
    2500: '525',
  },
};
